import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id F98CD2ED-FD62-414E-9116-94BA99713526
 * name equal-box
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/equal-box.svg
 * tags
 * - Math 
 */
export const EqualBoxIcon = createSvgIcon(<><path d="M17,16V14H7V16H17M19,3A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5C3.89,21 3,20.1 3,19V5C3,3.89 3.89,3 5,3H19M17,10V8H7V10H17Z" /></>, 'EqualBoxIcon');
export default EqualBoxIcon